module.exports = __webpack_public_path__ + "static/media/no.74dba218.svg";